export const config = {
    java_api_url: "https://evote.siriusuniversity.ru/api",
    auth_api_url: "https://evote.siriusuniversity.ru/auth",
    admin_url: "https://admin.evote.siriusuniversity.ru/",
    ws_connect: "wss://evote.siriusuniversity.ru/ws",
    ws_pass: "client",
    ws_user: "client",
    enable_esia: false,
    confidentiality: "http://docs.cryptoveche.ru/files/cryptoveche_pk.pdf",
    type: 'main',
    realm: "REALM_CRYPTOVECHE",
    header_view: "",
    localStorageVersion: 2,
    specialOpinion: false
};
